import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { cn } from './cn';
import { Tooltip } from './Tooltip';

export interface InfoTooltipProps {
  /** The explanatory text. */
  label: ReactNode;
  /** Accessible name for the info trigger (defaults to "More information"). */
  ariaLabel?: string;
  size?: number;
  className?: string;
}

/**
 * A labelled info affordance — a small info icon that reveals a tooltip and, unlike
 * a bare icon, carries an accessible name. Use it for the "(?)" explanations that
 * were previously bare unlabeled icons or emoji across dense pages.
 */
export function InfoTooltip({ label, ariaLabel = 'More information', size = 15, className }: InfoTooltipProps) {
  return (
    <Tooltip label={label}>
      <button
        type="button"
        aria-label={ariaLabel}
        className={cn(
          'inline-grid place-items-center rounded-full text-subtle transition-colors hover:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40',
          className,
        )}
      >
        <Info style={{ width: size, height: size }} />
      </button>
    </Tooltip>
  );
}
